import { Injectable } from '@angular/core';
import { ServerService } from '../core/service/server.service';
import { ServiceDefault } from '../core/service/service-default';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService extends ServiceDefault {
  private usuario;

  constructor(server: ServerService) {
    super('usuario', server);
  }

  changePass(obj) {
    return this._server.post(this.api + '/change-pass', obj);
  }

  setUsuario(usuario) {
    this.usuario = usuario;
  }

  getUsuario() {
    return this.usuario;
  }
}
